import React from "react";

/**
 * 90s starburst sticker badge.
 * Props: children (text), color (red|gold|magenta|bone), rotate (deg), size (px), className
 */
export const StickerBadge = ({
  children,
  color = "red",
  rotate = 12,
  size = 160,
  spin = true,
  className = "",
  textColor = "bone",
  testId = "sticker-badge",
}) => {
  const fill = {
    red: "#E63946",
    gold: "#D4A93C",
    magenta: "#FF2D87",
    bone: "#F4F1EA",
    navy: "#0A1F44",
  }[color];

  const txt = {
    bone: "#F4F1EA",
    navy: "#0A1F44",
    red: "#E63946",
  }[textColor];

  return (
    <div
      data-testid={testId}
      className={`relative inline-grid place-items-center ${className}`}
      style={{
        width: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg
        viewBox="0 0 200 200"
        className={`absolute inset-0 w-full h-full ${spin ? "animate-spin-slow" : ""}`}
        aria-hidden
      >
        {/* 24-point starburst */}
        <g transform="translate(100,100)">
          {Array.from({ length: 24 }).map((_, i) => {
            const a = (i * Math.PI * 2) / 24;
            const r = i % 2 === 0 ? 95 : 70;
            const x = Math.cos(a) * r;
            const y = Math.sin(a) * r;
            return null;
          })}
          <polygon
            fill={fill}
            stroke="#0A1F44"
            strokeWidth="3"
            points={Array.from({ length: 24 })
              .map((_, i) => {
                const a = (i * Math.PI * 2) / 24 - Math.PI / 2;
                const r = i % 2 === 0 ? 95 : 70;
                return `${Math.cos(a) * r},${Math.sin(a) * r}`;
              })
              .join(" ")}
          />
        </g>
      </svg>
      <span
        className="relative font-display uppercase text-center leading-none px-3"
        style={{
          color: txt,
          fontSize: size * 0.18,
          maxWidth: size * 0.75,
          textShadow: "0 2px 0 rgba(0,0,0,0.15)",
        }}
      >
        {children}
      </span>
    </div>
  );
};

export default StickerBadge;
